import React, { useState } from 'react';

import { track } from '~/src/dash/analytics/analytics';
import { hasRoleSuperUser } from '~/src/dash/utils/roles';
import { useMobileConfig, useMobileStore } from '~/src/dash/views/mobile/contexts';
import { EDashboardTab } from '~/src/dash/views/mobile/MobileBaseView/config';
import { MobileDashboardStore } from '~/src/dash/views/mobile/MobileBaseView/Home/contexts';
import { MobileDashboardLive } from '~/src/dash/views/mobile/MobileBaseView/Home/MobileDashboardLive';
import { MobileDashboardOverview } from '~/src/dash/views/mobile/MobileBaseView/Home/MobileDashboardOverview';

export const MobileDashboard = () => {
  const { user } = useMobileStore();
  const isSuperUser = hasRoleSuperUser(user.user);
  const { Dashboards } = useMobileConfig();
  const { defaultState, tabs } = Dashboards.Main;
  const [activeTab, setActiveTab] = useState(defaultState.tab);

  const handleChangeTab = (tab: string | number): void => {
    setActiveTab(Number(tab));
    track(
      'Mobile Dash - Switch Dashboards',
      { isSuperUser, dashboard: EDashboardTab[Number(tab)] },
      user.user,
    );
  };

  return (
    <MobileDashboardStore.Provider value={{ tabs, activeTab, handleChangeTab }}>
      <>
        {activeTab === EDashboardTab.Overview && <MobileDashboardOverview />}
        {activeTab === EDashboardTab.Live && <MobileDashboardLive />}
      </>
    </MobileDashboardStore.Provider>
  );
};
